import React from 'react';
import classNames from 'classnames';

import { formatPrice } from 'app/lib/formatters';

type Props = {
  value?: number;
  thousandsSeparator?: string;
  skipTruncate?: boolean;
  className?: string;
  betId?: string;
};

export const BetPrice = ({ value, thousandsSeparator = '', skipTruncate, betId, className }: Props) => {
  return (
    <span className={classNames('price', className)}
          data-test={`bet-${betId}-priceValue`}>
      {typeof value === 'number' ? formatPrice(value, { skipTruncate, thousandsSeparator }) : '—'}
    </span>
  );
};
